import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "containerIFrameWeet"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "loaderFullScreenElement"
};
const _hoisted_4 = {
  class: "returnOldInterface"
};
const _hoisted_5 = {
  key: 0,
  class: "height100"
};
const _hoisted_6 = {
  class: "playerContainer"
};
const _hoisted_7 = {
  class: "topLine"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "savingWaiting"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_w_dialog = _resolveComponent("w-dialog");
  const _component_icon_button = _resolveComponent("icon-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_w_dialog, {
    visible: _ctx.editMode,
    fullscreen: true,
    "append-to-body": !_ctx.returnToJquery,
    "custom-class": 'backgroundOverlayEditingWeet',
    closeOnOutsideClick: false
  }, {
    default: _withCtx(() => [_ctx.editMode ? (_openBlock(), _createElementBlock("iframe", {
      key: 0,
      onLoad: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.iFrameLoaded && _ctx.iFrameLoaded(...args)),
      "data-test": "weetIframe",
      src: _ctx.urlEditing,
      class: "iFrameFullForEditing",
      allow: "fullscreen *;camera *;microphone *;display-capture *;autoplay *"
    }, null, 40, _hoisted_2)) : _createCommentVNode("", true), _createVNode(_Transition, {
      name: "fade"
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_3, [_createVNode(_component_loader)], 512), [[_vShow, _ctx.loadingInterface]])]),
      _: 1
    }), _ctx.oldUIAvailableBoolean ? (_openBlock(), _createBlock(_Transition, {
      key: 1,
      name: "bounce"
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
        class: "linkLegacy",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.goToOldInterface())
      }, _toDisplayString(_ctx.$t('weet.returnToOldUIButton')) + " >", 1)], 512), [[_vShow, !_ctx.desactivateLegacyLink && !_ctx.weetID]])]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible", "append-to-body"]), _ctx.playerMode ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_Transition, {
    name: "fade",
    class: "transitionContainer"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_icon_button, {
      class: "buttonModes",
      icon: "pencil-outline",
      "tooltip-position": 'top',
      tooltip: _ctx.$t('weet.edit'),
      onClick: _ctx.switchEditMode
    }, null, 8, ["tooltip", "onClick"]), _createVNode(_component_icon_button, {
      class: "buttonModes",
      icon: "content-cut",
      "tooltip-position": 'top',
      tooltip: _ctx.$t('weet.cut'),
      onClick: _ctx.cutMode
    }, null, 8, ["tooltip", "onClick"]), _createVNode(_component_icon_button, {
      class: "buttonModes",
      icon: "message-outline",
      "tooltip-position": 'top',
      tooltip: _ctx.$t('weet.annotation'),
      onClick: _ctx.annotationMode
    }, null, 8, ["tooltip", "onClick"]), _createVNode(_component_icon_button, {
      class: "buttonModes",
      icon: "cursor-default-click-outline",
      "tooltip-position": 'top',
      tooltip: _ctx.$t('weet.interaction'),
      onClick: _ctx.interactionMode
    }, null, 8, ["tooltip", "onClick"]), _ctx.transcriptEnabledBoolean ? (_openBlock(), _createBlock(_component_icon_button, {
      key: 0,
      class: "buttonModes",
      icon: "subtitles-outline",
      "tooltip-position": 'top',
      tooltip: _ctx.$t('weet.transcript'),
      onClick: _ctx.transcriptMode
    }, null, 8, ["tooltip", "onClick"])) : _createCommentVNode("", true), _createVNode(_component_icon_button, {
      class: "buttonModes",
      icon: "microphone-outline",
      "tooltip-position": 'top',
      tooltip: _ctx.$t('weet.voiceOver'),
      onClick: _ctx.voiceOverMode
    }, null, 8, ["tooltip", "onClick"]), _createVNode(_component_icon_button, {
      class: "buttonModes",
      icon: "download-outline",
      "tooltip-position": 'top',
      tooltip: _ctx.$t('weet.download'),
      onClick: _ctx.downloadMode
    }, null, 8, ["tooltip", "onClick"])]), _createElementVNode("iframe", {
      src: _ctx.urlPlayer,
      "data-test": "weetIframe",
      class: "iFrameWeetPlayer",
      allow: "fullscreen *;camera *;microphone *;display-capture *;autoplay *"
    }, null, 8, _hoisted_8)], 512), [[_vShow, _ctx.weetID && !_ctx.saving]])]),
    _: 1
  }), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_9, [_createVNode(_component_loader)], 512), [[_vShow, _ctx.weetID && _ctx.saving]])]),
    _: 1
  })])) : _createCommentVNode("", true)]);
}